import { render, staticRenderFns } from "./MyVacancyCard.htm?vue&type=template&id=035bbd6c&scoped=true&"
import script from "./MyVacancyCard.ts?vue&type=script&lang=js&"
export * from "./MyVacancyCard.ts?vue&type=script&lang=js&"
import style0 from "./MyVacancyCard.scss?vue&type=style&index=0&id=035bbd6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bbd6c",
  null
  
)

export default component.exports